export default __webpack_public_path__ + "static/media/barbaraKlein.69b1686b.jpg";